import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
// models
import { AppState } from '../../../booking/models/app-state.interface';
// service
import { LoginService } from '../../services/login.service';

@Component({
  selector: 'app-login-display',
  templateUrl: './login-display.component.html',
  styleUrls: ['./login-display.component.scss']
})
export class LoginDisplayComponent implements OnInit, OnDestroy {

  @Output()
  userActive: EventEmitter<any> = new EventEmitter();

  private _userSubscription: Subscription;

  public user;

  constructor(
    private _appStore: Store<AppState>,
    private _loginService: LoginService
  ) { }

  ngOnInit() {
    this._userSubscription = this._appStore.select('userReducer')
      .subscribe((user: any) => {
        this.user = user.userDetails;
      });
  }

  logout() {
    this._loginService.logout();
    this.userActive.emit(false);
  }

  ngOnDestroy() {
    this._userSubscription.unsubscribe();
  }

}
